export default __webpack_public_path__ + "static/media/bad.28666681.png";